var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choose-size"},[_c('main-btn',{staticClass:"choose-size__btn",attrs:{"aria-label":_vm.$t('productCard.chooseSize')},on:{"click":_vm.showPopup}},[_vm._v(_vm._s(_vm.$t('productCard.chooseSize')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }